import {
    CREATE_PURCHASE_CHALLAN,
    DELETE_PURCHASE_CHALLAN,
    GET_PURCHASE_CHALLANS,
    PURCHASE_CHALLAN_REQUEST,
    PURCHASE_CHALLAN_REQUEST_FAILURE,
    UPDATE_PURCHASE_CHALLAN,
    GET_PURCHASE_CHALLANS_PAGE,
    PURCHASE_CHALLAN_REQUEST_SUCCESS
  } from "../types/purchase-challan-types";
  
  const initialState = {
    purchaseChallans: [],
    purchaseChallansPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const purchaseChallanReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_CHALLAN_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PURCHASE_CHALLANS: {
        return {
          ...state,
          purchaseChallans: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PURCHASE_CHALLANS_PAGE: {
          const { data, total, page, pageSize, search, where } = action.payload || {};
          return {
            ...state,
            purchaseChallansPage: [...data],
            total,
            page,
            pageSize,
            search: search || '',
            where: where || {},
            loading: false,
            error: null
          }
        }
      case CREATE_PURCHASE_CHALLAN:
        return {
          ...state,
          purchaseChallans: [action.payload, ...state.purchaseChallans],
          loading: false,
          error: null
        };
      case PURCHASE_CHALLAN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case UPDATE_PURCHASE_CHALLAN:
        const purchaseChallansData = state.purchaseChallans.slice(0);
        const uIndex = purchaseChallansData.findIndex((data) => data.id === action.payload.id);
        purchaseChallansData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          purchaseChallans: [ ...purchaseChallansData ],
          loading: false,
          error: null
        };
      case DELETE_PURCHASE_CHALLAN:
        const purchaseChallans = state.purchaseChallans?.slice(0);
        const index = purchaseChallans.findIndex((data) => data.id === action.id);
        if (index > -1) {
          purchaseChallans.splice(index, 1);
        }
        return {
          ...state,
          purchaseChallans: [...purchaseChallans],
          loading: false,
          error: null
        }
      case PURCHASE_CHALLAN_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default purchaseChallanReducer;
  